import { Badge } from "@/components/ui/badge";

export const ServiceBadge = ({ serviceTag }) => {
    return <Badge variant="beige">{serviceTag}</Badge>;
};
